import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import { ObjectPropsPropType } from '../../../../services/proptypes';
var propTypes = {
  collection: PropTypes.arrayOf(ObjectPropsPropType).isRequired,
  predicate: PropTypes.oneOfType([ObjectPropsPropType, PropTypes.func, PropTypes.arrayOf(PropTypes.any)]),
  targetFields: PropTypes.arrayOf(PropTypes.string)
};
var defaultProps = {
  predicate: {},
  targetFields: []
};
export default function Find(_ref) {
  var collection = _ref.collection,
    predicate = _ref.predicate,
    targetFields = _ref.targetFields;
  // See lodash find: https://lodash.com/docs/4.17.15#find
  var foundItem = _find(collection, predicate);
  if (_isEmpty(foundItem)) {
    return null;
  }
  if (_isEmpty(targetFields)) {
    return foundItem;
  }
  if (targetFields.length === 1) {
    return foundItem[targetFields[0]];
  }
  return targetFields.reduce(function (acc, field) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, field, foundItem[field]));
  });
}
Find.propTypes = propTypes;
Find.defaultProps = defaultProps;